
const PopupCancel = ({close, cancel, eventTypeId}) => {

    return (
        <div className="popup-meeting">
            <div className="popup-meeting__close" onClick={close}></div>
            <div className="popup-meeting__wrap">
                <div className="popup-meeting__title">Отмена {eventTypeId == 1 ? 'встречи' : 'брокер-тура'}</div>
                <div className="popup-meeting__status popup-meeting__status_error">Вы уверены, что хотите отменить {eventTypeId == 1 ? 'встречу' : 'брокер-тур'}? </div>
                <div className="popup-meeting__buy">Все заполненные данные будут удалены!</div>
                <div className="popup-meeting__buttons">
                    <button className="btn" onClick={close}>Нет, продолжить</button>
                    <button className="btn btn_empty" onClick={cancel}>Да, отменить</button>
                </div>
            </div>
        </div>
    )
}

export default PopupCancel